import axios from 'axios'
import ProveedoresPDVService from '../../service/ProveedoresPDVService'
import UsuariosService from '../../service/UsuariosService'

export default {
    namespaced: true,
    state: {
        status: '',
        token: localStorage.getItem('token') || '',
        usuario: {},
        pdv: {},
    },
    mutations: {
        SET_STATUS(state, nuevoStatus) {
            state.status = nuevoStatus
        },
        SET_TOKEN(state, token) {
            state.token = token
        },
        SET_USUARIO(state, usuario) {
            state.usuario = usuario
        },
        SET_PDV(state, pdv) {
            state.pdv = pdv
        },
    },
    actions: {
        async login({ commit }, datos) {

            commit('SET_STATUS', 'loading')

            const respuesta = await UsuariosService.login(datos);

            if (respuesta.success === true) {

                const token = respuesta.token;

                localStorage.setItem('token', token);

                axios.defaults.headers.common['Authorization'] = `Bearer ${token}`

                await this.dispatch('auth/obtenerDatos');

                commit('SET_TOKEN', token);

            } else {
                this.dispatch('auth/logout', { status: 'error' });
            }
        },
        async loginPDV({ commit }, datos) {

            commit('SET_STATUS', 'loading')

            const respuesta = await ProveedoresPDVService.loginPDV(datos);

            if (respuesta.success === true) {

                const token = respuesta.token;

                localStorage.setItem('token', token);

                axios.defaults.headers.common['Authorization'] = `Bearer ${token}`

                commit('SET_TOKEN', token);

                commit('SET_STATUS', 'success')
                commit('SET_PDV', respuesta.pdv)

            } else {
                this.dispatch('auth/logoutPDV', { status: 'error' });
            }
        },
        async obtenerDatos({ commit }) {

            commit('SET_STATUS', 'loading')

            const respuesta = await UsuariosService.me();

            if (respuesta.success === true) {
                commit('SET_STATUS', 'success')
                commit('SET_USUARIO', respuesta.usuario)
            } else {
                this.dispatch('auth/logout', { status: 'error' });
            }

        },
        async obtenerDatosPDV({ commit }) {

            commit('SET_STATUS', 'loading')

            const respuesta = await ProveedoresPDVService.pdv();

            if (respuesta.success === true) {

                commit('SET_STATUS', 'success')
                commit('SET_PDV', respuesta.proveedor_pdv)

            } else {
                this.dispatch('auth/logoutPDV', { status: 'error' });
            }
        },
        logout({ commit }, payload) {
            commit('SET_STATUS', (payload && payload.status) ? payload.status : '')
            commit('SET_TOKEN', '')
            commit('SET_USUARIO', {})

            localStorage.removeItem('token')
            delete axios.defaults.headers.common['Authorization']
        },
        logoutPDV({ commit }, payload) {
            commit('SET_STATUS', (payload && payload.status) ? payload.status : '')
            commit('SET_TOKEN', '')
            commit('SET_PDV', {})

            localStorage.removeItem('token')
            delete axios.defaults.headers.common['Authorization']
        }
    },
    getters: {
        isLogueado: (state) => {
            if (typeof state.usuario.usuario !== 'undefined') {
                return true;
            }
            return false;
        },
        isLogueadoPDV: (state) => {
            if (typeof state.pdv.id !== 'undefined') {
                return true;
            }
            return false;
        },
        usuarioActual: state => state.usuario,
        pdvActual: state => state.pdv,
        hasToken: state => !!state.token,
        getStatus: state => state.status,
    }
}